import { freeze } from "immer";

export const IngredientTab = freeze(
  {
    General: "general",
    Nutrition: "nutrition",
    Label: "label",
    LabelIngredients: "label-ingredients",
    Photos: "photos",
    Price: "price",
    UsedInRecipes: "used-in-recipes",
  } as const,
  true,
);
